import React from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import {
  Home,
  AboutUs,
  BlogDetail,
  Blogs,
  GuestPost,
  ContactUs,
  Customer,
  Design,
  DigitalMarketing,
  Frontend,
  WebDeveloment,
  Animations,
  ERP,
  Tools,
  Product,
  Team,
  UserProfile,
} from "../views";

import WritePost from "../views/writepost/WritePost";
import RegisterBusiness from "../views/registerBusniness/RegisterBusiness";
import Businesses from "../views/businessListing/businessListing";
import businessDetail from "../views/businessListing/businessDetail";

// Array of routes with their respective components
const routes = [
  { path: "/write-post", name: "Write Post", component: WritePost },
  { path: "/register-business", name: "Register Business", component: RegisterBusiness },
  { path: "businesses", name: "Businesses", component: Businesses },
  { path: "business-detail/:slug", name: "Business Detail", component: businessDetail },
  { path: "/", name: "Home", component: Home },
  { path: "tools", name: "Tools", component: Tools },
  { path: "/about", name: "About", component: AboutUs },
  { path: "blogs/:slug", name: "Blog Detail", component: BlogDetail },
  { path: "blogs", name: "Blogs", component: Blogs },
  { path: "guest-post", name: "Guest Post", component: GuestPost },
  { path: "contact-us", name: "Contact Us", component: ContactUs },
  { path: "who-we-help", name: "Who We Help", component: Customer },
  { path: "services/erp-business-software", name: "ERP Business Software", component: ERP },
  { path: "services/web-design", name: "Design", component: Design },
  { path: "services/web-development", name: "Frontend Development", component: Frontend },
  {
    path: "services/digital-marketing",
    name: "Digital Marketing",
    component: DigitalMarketing,
  },
  {
    path: "services/web-application-development",
    name: "Web App Development",
    component: WebDeveloment,
  },
  {
    path: "services/video-editing-marketing",
    name: "Video Editing Marketing",
    component: Animations,
  },
  { path: "user-profile", name: "User Profile", component: UserProfile },
];

const AppContent = () => {
  const location = useLocation();

  return (
    <>
      <div className="main_panel w-100">
        <div className="content_wrapper ms-0">
          <Routes key={location.pathname} location={location}>
            {routes.map((route, index) => (
              <Route
                key={index}
                path={route.path}
                name={route.name}
                element={<route.component />}
              />
            ))}
            {/* Redirect /about to home */}
            <Route path="about" element={<Navigate to="/" replace />} />
            {/* 404 or default route */}
            <Route path="*" element={<Navigate to="not-found" replace />} />
          </Routes>
        </div>
      </div>
    </>
  );
};

export default AppContent;
